module.exports = __webpack_public_path__ + "img/1.af884716.png";